import { Component, ViewChild, ViewContainerRef } from '@angular/core';
import { DatePartsFilterComponent } from 'libs/visual-lib/src/lib/modules/custom-filters/components/date-parts-filter/date-parts-filter.component';
import { DatePart } from 'libs/visual-lib/src/lib/modules/custom-filters/models/date-part.enum';

@Component({
  selector: 'siq-month-filter',
  templateUrl: './month-filter.component.html',
  styleUrls: ['./month-filter.component.scss', '../../styles/custom-filters.scss']
})
export class MonthFilterComponent extends DatePartsFilterComponent {
  public months: string[] = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
  @ViewChild('month', { read: ViewContainerRef }) private _input;

  constructor() {
    super();
    this.setDatePart(DatePart.MONTH);
  }

  // Focuses on the month element upon initialization of the filter controller
  // AfterViewInit interface implemented by inherited class
  // tslint:disable-next-line:use-life-cycle-interface
  ngAfterViewInit(): void {
    setTimeout(() => {
      this._input && this._input.element.nativeElement.focus();
    });
  }
}
